import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Empresa } from '../../entities/empresa';
import { Api } from '../../providers/api/api';

import * as _ from 'lodash';

interface IndicadorOrdemCompraMultiloja {
    MaterialPrimarioDia: number;
    MaterialSecundarioDia: number;
    OutrosMateriaisDia: number;
    MaterialPrimarioMes: number;
    MaterialSecundarioMes: number;
    OutrosMateriaisMes: number;
    MaterialPrimarioAno: number;
    MaterialSecundarioAno: number;
    OutrosMateriaisAno: number;
    TotalOrdemCompraDia: number;
    TotalOrdemCompraMes: number;
    TotalOrdemCompraAno: number;
    Empresa: Empresa;
}

@Component({
    selector: 'indicador-oc-multilojas',
    templateUrl: './indicador-oc-multilojas.html'
})
export class IndicadorOrdemCompraMultilojasComponent implements OnInit, OnDestroy {
    @Input('analytic') analytic: boolean = false;

    public data: Date = new Date();

    public ordemCompraMultilojaDilady: IndicadorOrdemCompraMultiloja;
    public ordemCompraMultilojaLoveSecret: IndicadorOrdemCompraMultiloja;
    public ordemCompraMultilojaBanhoDeMar: IndicadorOrdemCompraMultiloja;
    public ordemCompraMultilojaDoctorSecret: IndicadorOrdemCompraMultiloja;
    public ordemCompraMultilojaGrupo: any;

    public carregandoDados: boolean = true;

    private _myInterval: number;

    constructor(
        private _api: Api
    ) { }

    public ngOnInit(): void {
        this._separarLojas();

        this._myInterval = setInterval(() => {
            this._separarLojas();
        }, 30000);
    }

    public ngOnDestroy(): void {
        clearInterval(this._myInterval);
    }

    private _separarLojas(): void {
        this._obterIndicadorOrdemCompraMultiloja().then(indicadores => {
            this.ordemCompraMultilojaDilady = indicadores.find(a => _.isEqual(a.Empresa.Id, 1));
            this.ordemCompraMultilojaDilady.TotalOrdemCompraDia = (this.ordemCompraMultilojaDilady.MaterialPrimarioDia + this.ordemCompraMultilojaDilady.MaterialSecundarioDia + this.ordemCompraMultilojaDilady.OutrosMateriaisDia);
            this.ordemCompraMultilojaDilady.TotalOrdemCompraMes = (this.ordemCompraMultilojaDilady.MaterialPrimarioMes + this.ordemCompraMultilojaDilady.MaterialSecundarioMes + this.ordemCompraMultilojaDilady.OutrosMateriaisMes);
            this.ordemCompraMultilojaDilady.TotalOrdemCompraAno = (this.ordemCompraMultilojaDilady.MaterialPrimarioAno + this.ordemCompraMultilojaDilady.MaterialSecundarioAno + this.ordemCompraMultilojaDilady.OutrosMateriaisAno);

            this.ordemCompraMultilojaLoveSecret = indicadores.find(a => _.isEqual(a.Empresa.Id, 2));
            this.ordemCompraMultilojaLoveSecret.TotalOrdemCompraDia = (this.ordemCompraMultilojaLoveSecret.MaterialPrimarioDia + this.ordemCompraMultilojaLoveSecret.MaterialSecundarioDia + this.ordemCompraMultilojaLoveSecret.OutrosMateriaisDia);
            this.ordemCompraMultilojaLoveSecret.TotalOrdemCompraMes = (this.ordemCompraMultilojaLoveSecret.MaterialPrimarioMes + this.ordemCompraMultilojaLoveSecret.MaterialSecundarioMes + this.ordemCompraMultilojaLoveSecret.OutrosMateriaisMes);
            this.ordemCompraMultilojaLoveSecret.TotalOrdemCompraAno = (this.ordemCompraMultilojaLoveSecret.MaterialPrimarioAno + this.ordemCompraMultilojaLoveSecret.MaterialSecundarioAno + this.ordemCompraMultilojaLoveSecret.OutrosMateriaisAno);

            this.ordemCompraMultilojaBanhoDeMar = indicadores.find(a => _.isEqual(a.Empresa.Id, 3));
            this.ordemCompraMultilojaBanhoDeMar.TotalOrdemCompraDia = (this.ordemCompraMultilojaBanhoDeMar.MaterialPrimarioDia + this.ordemCompraMultilojaBanhoDeMar.MaterialSecundarioDia + this.ordemCompraMultilojaBanhoDeMar.OutrosMateriaisDia);
            this.ordemCompraMultilojaBanhoDeMar.TotalOrdemCompraMes = (this.ordemCompraMultilojaBanhoDeMar.MaterialPrimarioMes + this.ordemCompraMultilojaBanhoDeMar.MaterialSecundarioMes + this.ordemCompraMultilojaBanhoDeMar.OutrosMateriaisMes);
            this.ordemCompraMultilojaBanhoDeMar.TotalOrdemCompraAno = (this.ordemCompraMultilojaBanhoDeMar.MaterialPrimarioAno + this.ordemCompraMultilojaBanhoDeMar.MaterialSecundarioAno + this.ordemCompraMultilojaBanhoDeMar.OutrosMateriaisAno);

            this.ordemCompraMultilojaDoctorSecret = indicadores.find(a => _.isEqual(a.Empresa.Id, 5));
            this.ordemCompraMultilojaDoctorSecret.TotalOrdemCompraDia = (this.ordemCompraMultilojaDoctorSecret.MaterialPrimarioDia + this.ordemCompraMultilojaDoctorSecret.MaterialSecundarioDia + this.ordemCompraMultilojaDoctorSecret.OutrosMateriaisDia);
            this.ordemCompraMultilojaDoctorSecret.TotalOrdemCompraMes = (this.ordemCompraMultilojaDoctorSecret.MaterialPrimarioMes + this.ordemCompraMultilojaDoctorSecret.MaterialSecundarioMes + this.ordemCompraMultilojaDoctorSecret.OutrosMateriaisMes);
            this.ordemCompraMultilojaDoctorSecret.TotalOrdemCompraAno = (this.ordemCompraMultilojaDoctorSecret.MaterialPrimarioAno + this.ordemCompraMultilojaDoctorSecret.MaterialSecundarioAno + this.ordemCompraMultilojaDoctorSecret.OutrosMateriaisAno);


            this.ordemCompraMultilojaGrupo = {
                MaterialPrimarioDia: _.sum(indicadores.map(a => a.MaterialPrimarioDia)),
                MaterialSecundarioDia: _.sum(indicadores.map(a => a.MaterialSecundarioDia)),
                OutrosMateriaisDia: _.sum(indicadores.map(a => a.OutrosMateriaisDia)),
                MaterialPrimarioMes: _.sum(indicadores.map(a => a.MaterialPrimarioMes)),
                MaterialSecundarioMes: _.sum(indicadores.map(a => a.MaterialSecundarioMes)),
                OutrosMateriaisMes: _.sum(indicadores.map(a => a.OutrosMateriaisMes)),
                MaterialPrimarioAno: _.sum(indicadores.map(a => a.MaterialPrimarioAno)),
                MaterialSecundarioAno: _.sum(indicadores.map(a => a.MaterialSecundarioAno)),
                OutrosMateriaisAno: _.sum(indicadores.map(a => a.OutrosMateriaisAno)),
                TotalOrdemCompraDia: (this.ordemCompraMultilojaDilady.TotalOrdemCompraDia + this.ordemCompraMultilojaLoveSecret.TotalOrdemCompraDia + this.ordemCompraMultilojaBanhoDeMar.TotalOrdemCompraDia),
                TotalOrdemCompraMes: (this.ordemCompraMultilojaDilady.TotalOrdemCompraMes + this.ordemCompraMultilojaLoveSecret.TotalOrdemCompraMes + this.ordemCompraMultilojaBanhoDeMar.TotalOrdemCompraMes),
                TotalOrdemCompraAno: (this.ordemCompraMultilojaDilady.TotalOrdemCompraAno + this.ordemCompraMultilojaLoveSecret.TotalOrdemCompraAno + this.ordemCompraMultilojaBanhoDeMar.TotalOrdemCompraAno)
            }

            setTimeout(() => {
                this.carregandoDados = false;
            }, 1000);
        }).catch(error => {
            console.error(error);
        });
    }

    private _obterIndicadorOrdemCompraMultiloja(): Promise<IndicadorOrdemCompraMultiloja[]> {
        return new Promise((resolve, reject) => {
            this._api.get('IndicadorOrdemCompraMultiloja').subscribe(response => resolve(JSON.parse(response._body)), reject);
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/indicador-oc-multilojas/indicador-oc-multilojas.ts